import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'container',
  props: {
  /** 背景图 */
  bgImg: String,
  /** 标题 */
  title: String,
},
  setup(__props) {

const props = __props


const styleObj = computed(() => {
  if (props.bgImg) {
    return {
      'background-image': `url(${`${props.bgImg}`})`,
    };
  }
  return {};
});

return { __sfc: true,props, styleObj }
}

})